var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "width": "1224",
      "maxWidth": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "scroll-primary pr-10",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-x": "hidden",
      "overflow-y": "auto"
    }
  }, [_c('vertical-form-table', _vm._b({}, 'vertical-form-table', {
    items: _vm.items
  }, false), [!_vm.value.isSigned ? _c('template', {
    slot: "계약서 서식"
  }, _vm._l(this.value.pages, function (page) {
    return _c('worker-form-page', {
      key: page.page,
      attrs: {
        "value": Object.assign({}, _vm.value, {
          page: page
        })
      }
    });
  }), 1) : _vm._e()], 2)], 1), _c('div', {
    staticClass: "v-btn-group flex-wrap"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_c('span', [_vm._v("확인")])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }